import { useState } from 'react';

export const usePersonPrint = () => {
  const [printPersonId, setPrintPersonId] = useState<string | null>(null);

  const print = (personId: string) => setPrintPersonId(personId);
  const closePrint = () => setPrintPersonId(null);

  return { printPersonId, print, closePrint };
};
